// src/components/CommentsSection.js
import React from "react";

const CommentsSection = ({ comments }) => {
    if (!comments || comments.length === 0) {
        return <p>No comments available</p>;
    }

    return (
        <div style={{ marginTop: 16 }}>
            {/* <h4>Comments</h4> */}
            {comments.map((comment, index) => (
                <div key={index} style={{ marginBottom: 8 }}>
                    <p>{comment.comment}</p>
                </div>
            ))}
        </div>
    );
};

export default CommentsSection;
